import { createSelector } from "reselect";

const getCommonStore = (state) => state.common;

export const checkNetworkConnection = createSelector(getCommonStore, (common) => common.networkConnected);

export const showAppleInstallationDrawer = createSelector(getCommonStore, (common) => common.showAppleInstallationDrawer); //prettier-ignore

export const getPrivacyAcceptedFlag = createSelector(getCommonStore, (common) => common.privacyAccepted);

const getOspedaliStore = createSelector(getCommonStore, (common) => common.ospedali);

export const getOspedali = createSelector(getOspedaliStore, (ospedali) => ospedali.data);
export const fetchOspedaliEnded = createSelector(getOspedaliStore, (ospedali) => ospedali.fetchEnded);
